export const blockIconsEditorAttachMoney = (
	<span className='material-symbols-outlined'>attach_money</span>
);
